import { DEFAULT_ADMIN_NAMESPACE } from '@cli-constants/scaffolding.js'
import { resolveAdminNamespace } from '@next-adapter/config/namespace/resolve-admin-namespace.js'
import { renderAdminDataTemplateGeneratedValueTemplate } from '@next-adapter/templates/renderers/init/templates/app/admin.js'

export function adminDataTemplate(
  projectName: string,
  namespaceValue = DEFAULT_ADMIN_NAMESPACE
): string {
  const namespace = resolveAdminNamespace(namespaceValue)

  return renderAdminDataTemplateGeneratedValueTemplate({
    namespaceCamel: String(namespace.camel),
    projectName: String(projectName)
  })
}
